import React, { CSSProperties } from 'react';

interface CheckboxProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  className?: string;
  style?: CSSProperties;
  backgroundColor?: string;
  checkedBackgroundColor?: string;
  title?: string;
  size?: number;
}

const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  onCheckedChange,
  className,
  style,
  title,
  backgroundColor = 'storyblueSecondLightText',
  checkedBackgroundColor = 'storyblueSecondLightText',
  size = 6,
}) => {
  return (
    <button
      type="button"
      className={`w-${size} h-${size} rounded border-2 flex items-center justify-center transition-colors hover:shadow ${
        checked ? `bg-${checkedBackgroundColor} border-${checkedBackgroundColor}` : `bg-white border-${backgroundColor}`
      } ${className}`}
      style={style}
      title={title || undefined}
      onClick={() => onCheckedChange(!checked)}
    >
      {checked && (
        <svg className="w-5 h-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
        </svg>
      )}
    </button>
  );
};
export default Checkbox;
